import React from "react"
import Paper from "@material-ui/core/Paper";
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import ChangePasswordDialog from './ChangePasswordDialog';
import {User, UserState} from "../../store/user/types";
import {connect} from "react-redux";
import {AppState} from "../../store";
import {thunkUserSave} from "../../store/thunks";

interface IProps {
    t: any;
    thunkUserSave: any;
    user: UserState;    
}

interface IHeaderState {
    user : User;
    dirty: boolean;
    showChangePasswordDialog : boolean;
}

class Profile extends React.Component <IProps, IHeaderState> {

    state = {
        user: this.props.user.user ? this.props.user.user : {login:''},
        showChangePasswordDialog: false,
        dirty : false
    };

    componentDidMount(): void {
        document.title = this.props.t('profile.doctitle')
    }

    handleChange = (name :string) => (event : React.ChangeEvent) => {        
        let key: (keyof User) = (name as any);
        let user2 = this.state.user;
        user2[key] = (event.target as HTMLInputElement).value;
        this.setState({ 'user': user2});
        this.setState({'dirty' : true});
    };

    showChangePasswordDialog = () => {
        this.setState({showChangePasswordDialog: true});
    }

    closeChangePasswordDialog = () => {
        this.setState({showChangePasswordDialog: false});
    }

    saveUser = () => {
        this.props.thunkUserSave(this.state.user);
    }


    render() {
        const { t } = this.props;
        return (
            <div>
                <h3> { t('profile.introduction') } </h3>
                <Paper style={{padding: "10px", margin: "25px"}}>
                    <table style={{margin: "10px"}}>
                      <tbody>
                        <tr>
                            <td><InputLabel>{t('profile.supplierNo')}</InputLabel></td>
                            <td><input readOnly value={this.state.user.supplierId}></input></td>
                        </tr>
                        <tr>
                            <td><InputLabel>{t('profile.login')}</InputLabel></td>
                            <td><input readOnly value={this.state.user.login}></input></td>
                        </tr>
                        <tr>
                            <td><InputLabel>{t('profile.companyName')}</InputLabel></td>
                            <td><input defaultValue={this.state.user.company} onChange={this.handleChange('company')}></input></td>
                        </tr>
                        <tr>
                            <td><InputLabel>{t('profile.salutation')}</InputLabel></td>
                            <td><input defaultValue={this.state.user.salutation} onChange={this.handleChange('salutation')}></input></td>
                        </tr>
                        <tr>
                            <td><InputLabel>{t('profile.firstName')}</InputLabel></td>
                            <td><input defaultValue={this.state.user.firstName} onChange={this.handleChange('firstName')}></input></td>
                        </tr>
                        <tr>
                            <td><InputLabel>{t('profile.lastName')}</InputLabel></td>
                            <td><input defaultValue={this.state.user.lastName} onChange={this.handleChange('lastName')}></input></td>
                        </tr>
                        <tr>
                            <td><InputLabel>{t('profile.street')}</InputLabel></td>
                            <td><input defaultValue={this.state.user.street} onChange={this.handleChange('street')}></input></td>
                        </tr>
                        <tr>
                            <td><InputLabel>{t('profile.postcode')}</InputLabel></td>
                            <td><input defaultValue={this.state.user.zipCode} onChange={this.handleChange('zipCode')}></input></td>
                        </tr>
                        <tr>
                            <td><InputLabel>{t('profile.city')}</InputLabel></td>
                            <td><input defaultValue={this.state.user.city} onChange={this.handleChange('city')}></input></td>
                        </tr>
                        <tr>
                            <td><InputLabel>{t('profile.email')}</InputLabel></td>
                            <td><input width="auto" defaultValue={this.state.user.email} onChange={this.handleChange('email')}></input></td>
                        </tr>
                        <tr>
                            <td><InputLabel>{t('profile.phone')}</InputLabel></td>
                            <td><input defaultValue={this.state.user.phone} onChange={this.handleChange('phone')}></input></td>
                        </tr>
                      </tbody>
                    </table>
                    <Button variant="contained" color="primary" disabled={!this.state.dirty} onClick={this.saveUser}>{t('profile.save')}</Button>
                    <Button style={{marginLeft: "10px"}}variant="contained" color="secondary" onClick={this.showChangePasswordDialog}>{t('profile.changePassword')}</Button>                 
                </Paper>
                <ChangePasswordDialog open={this.state.showChangePasswordDialog} t={this.props.t} closeDialog={this.closeChangePasswordDialog}/>
            </div>
        )
    }
}


const mapStateToProps = (state: AppState) => ({
    user: state.user
});


export default connect(mapStateToProps, {thunkUserSave})(Profile);